import { trackIsCpdLabelShow } from '../../../containers/OfferContainer/LabelsListContainer/tracking';
import { ELabelColor, ILabel } from '../../../types/label';
import { IJsonQuery } from 'shared/repositories/common/json_query';

export const getCpdLabel = ({
  offerId,
  position,
  jsonQuery,
}: {
  offerId: number;
  position: number;
  jsonQuery: IJsonQuery;
}): ILabel => {
  return {
    color: ELabelColor.BlueCpdLabel,
    text: 'Сделка на Циане',
    tooltip: {
      onOpen: () => trackIsCpdLabelShow(jsonQuery, { offerId, position }),
      description:
        // eslint-disable-next-line no-irregular-whitespace
        'Объект участвует в программе Сделка: надёжный агент от Циана проверит квартиру, поможет правильно оформить документы и убедится в безопасности расчётов. Всё это — под нашим контролем.',
    },
  };
};
